import React from 'react';
import { AlertProps, Alert, Box } from '@origin-digital/ods-core';

export const AlertContainer: React.FC<AlertProps> = (props) => (
  <Box paddingBottom="large">
    <Alert {...props}>{props.children}</Alert>
  </Box>
);
